// extracted by mini-css-extract-plugin
export default {"imageWrapper":"NF-z","hovered":"OF-z","hoverImage":"PF-z","mainImage":"QF-z","imageNoBackground":"RF-z","fullSizeImage":"SF-z"};